module.exports = __webpack_public_path__ + "static/media/avatar-5.e6bc68ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/avatars/avatar-5.png
// module id = 244
// module chunks = 0